import { currentVersion } from 'utils/index'
import SupportChat from '../SupportChat'
import ChatPlatform from './ChatPlatform'

/**
 * @see https://docs.helpscout.com/article/1237-get-started-with-live-chat
 * @see https://developer.helpscout.com/beacon-2/web/javascript-api/
 */
export default class HelpScout extends ChatPlatform {

	get name() { return 'Help Scout' }

	//would be good if we set this to true, so it can track better all user events... but it's not possible to hide the floating button once the chat is open (unless we resort to CSS hacks), so we keep this false for now
	get initOnStartup() { return false }

	get sluggifiedFields() { return true }

	init() {
		return new Promise(resolve => {
			console.debug('loading HS code')
			//@formatter:off
			//eslint-disable-next-line
			!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
			//@formatter:on

			console.debug('initializing Beacon')
			window.Beacon('init', this.account.chat.key)
			window.Beacon('on', 'ready', () => resolve(true))
			window.Beacon('on', 'open', () => SupportChat.internalToggle(true))
			window.Beacon('on', 'close', () => SupportChat.internalToggle(false))
			window.Beacon('config', {
				hideFABOnMobile: true, //it sniffs for actual mobile devices, so this can be seen with Device Emulation
			})

			//https://developer.helpscout.com/beacon-2/web/javascript-api/#beaconidentify-userobject
			const identification = {
				name     : this.user.display_name,
				email    : this.user.email,
				avatar   : this.account.logo['1x'],
				company  : `${this.account.display_name} (acc #${this.account.id})`,
				jobTitle : this.completeUsername,
				// 'phone': '',

				//custom properties are defined here: https://secure.helpscout.net/settings/properties/
				username        : this.completeUsername,
				'account-number': this.account.id,
				...this.extraDetails, //account-id, account-name, rest-names, rest-ids
			}
			if (this.account.chat.signature) {
				identification.signature = this.account.chat.signature
			}
			window.Beacon('identify', identification)

			//HS is complaining about an empty(?) invalid field, but I couldn't find it?
			// console.debug('identifying with HS', identification)

			window.Beacon('session-data', {
				'App version': currentVersion()
			})
		})
	}

	get isUp() { return 'Beacon' in window }
	open() { window.Beacon('open') }
	close() { window.Beacon('close') }
	nuke() { window.Beacon('destroy') }
}
